export const QUALTRICS_DIV_ID = 'ZN_SV34BdRhWeacsj7';
export const QUALTRICS_SCRIPT_SRC =
  'https://znsv34bdrhweacsj7-mercedesbenz.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_SV34BdRhWeacsj7';

export const QUALTRICS_DEFAULT_BRAND = 'MB';
export const QUALTRICS_BRAND_ATTRIBUTE = 'data-brand';

export const TENANT = 'seamless';
export const COMPONENT_NAME = 'seamless-qualtrics';

export const CONSENT_CONNECTION_NAME = 'ConsentContextConnection';
export const QUALTRICS_CONSENT_NAME = 'Qualtrics';

export const BRAND_CONTEXT_CONNECTION_NAME = 'BrandContextConnection';
